module.exports = __webpack_public_path__ + "img/noimage.385a02a4.jpg";